import Styled from "styled-components";

export const CategoriesContainer = Styled.div`
width: 100%;
display: flex;
flex-wrap: wrap;
justify-content: space-between;
`;
